/**
 * Staging — registry entry (Component only; completeness is registered separately
 * in `modules/completeness.ts` per the A-01 split).
 */

import type { PfConfigModule } from '../registry'
import { Staging } from './Staging.component'

export const stagingModule: PfConfigModule = {
  flowId: 'staging',
  Component: Staging,
}
